import '@/style.css';

import descope from '@descope/vue-sdk';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from '@/App.vue';
import { initSentry } from '@/plugins/sentry';
import router from '@/router';
import { captureAttributionFromUrl } from '@/services/attribution';
import { captureAdminConsentFromUrl } from '@/services/microsoftCapabilities';

// Capture the campaigns params before the router mounts: it rewrites the URL.
captureAttributionFromUrl();
// Capture Microsoft's consent answer before MSAL reads the URL.
captureAdminConsentFromUrl();

const app = createApp(App);
initSentry(app);
const pinia = createPinia();
app.use(pinia);
app.use(router);
app.use(descope, {
    projectId: import.meta.env.VITE_DESCOPE_PROJECT_ID || '',
    baseUrl: '',
    sessionTokenViaCookie: true
});

app.mount('#app');
